import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import { Globals } from '../_Globals/globals'; 

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

@Injectable() 
export class AuthenticationService {
    public token: string;
 
    public id: Number;
    constructor(private http: Http, private globals: Globals) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
    }

    adminLogin(username: string, password: string): Observable<boolean> {
        console.log(this._buildParams({ username: username, password: password }));
        return this.http.get(this.globals.api_url + 'agencies/login?' + this._buildParams({ username: username, password: password, token : this._rand(16, 16), device_id: 1 }))
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                console.log(response.json()); 
                let token = response.json() && response.json().token;
                let id = response.json() && response.json().auth.User.id;
                let acl = response.json() && response.json().auth.User.group_id;
                if (token) {
                    // set token property
                    this.token = token;
                    this.id = id;
                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({ id: id, acl: acl, username: username, token: token }));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }   
            });
    }

    login(username: string, password: string): Observable<boolean> {
        console.log(this._buildParams({ username: username, password: password }));
        return this.http.get(this.globals.api_url + 'apis/login?' + this._buildParams({ username: username, password: password, token : this._rand(16, 16), device_id: 1 }))
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                console.log(response.json()); 
                let token = response.json() && response.json().token; 
                let id = response.json() && response.json().auth.User.id;
                let acl = response.json() && response.json().auth.User.group_id;
                if (token) {
                    // set token property
                    this.token = token; 
                    this.id = id;
                    // store username and jwt token in local storage to keep user logged in between page refreshes
                     localStorage.setItem('currentUser', JSON.stringify({ id: id, acl: acl, username: username, token: token }));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }   
            });
    }

    resetPassword(email: string): Observable<boolean> { 
        return this.http.get(this.globals.api_url + 'apis/forgotpassword?' + this._buildParams({ email: email, token : this._rand(16, 16)}))
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                console.log(response); 
                let token = response.json() && response.json().status;
                if (token) { 
                    // return true to indicate successful reset
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }   
            });
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem('currentUser');
    }

    private _buildParams(params: any) {
        let urlSearchParams = new URLSearchParams();

        for(let key in params){
            if(params.hasOwnProperty(key)){
                urlSearchParams.append(key, params[key]);
            }
        }
        return urlSearchParams.toString();
    }

    private _rand(length, current) {
      current = current ? current : '';
      return length ? this._rand(--length, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".charAt(Math.floor(Math.random() * 60)) + current) : current;
    }
}


// WEBPACK FOOTER //
// ./src/app/_Services/authentication.service.ts